import { Injectable } from '@angular/core';
import { SharedService } from '../shared/shared.service';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { throwError, Subject, Observable } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import Swal from 'sweetalert2';

@Injectable()
export class SurveyService {
    private tempinvitationCode = new Subject<string>();
    public tempinvitationCode$ = this.tempinvitationCode.asObservable();

    invitationCode(inviCode: string) {
        this.tempinvitationCode.next(inviCode);
    }

    private apiUrl = '';
    constructor(private httpService: HttpClient, private sharedService: SharedService) {
        this.apiUrl = this.sharedService.getAPIUrl();
    }

    public updateParticipationDashboard(updateDashboard) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            })
        };
        const formData = JSON.stringify(updateDashboard);
        return this.httpService.post(this.apiUrl + '/api/Participant/UpdatePartipantExcelInfoBySurveyUId', formData, httpOptions)
            .pipe(retry(1), catchError(this.handleError));
    }

    public getDemographicDetailsBySurveyUId(surveyUID) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            })
        };
        const formData = JSON.stringify(surveyUID);
        return this.httpService.get(this.apiUrl + '/api/SurveyQuestionSetResponses/GetDemographicFieldsForRawData?surveyUId=' + surveyUID, httpOptions)
            .pipe(retry(1), catchError(this.handleError));
    }

    public saveActionPlan(actionPlanObj) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            })
        };
        const formData = JSON.stringify(actionPlanObj);
        return this.httpService.post(this.apiUrl + '/api/EngagementScorecard/SaveActionPlan', formData, httpOptions)
            .pipe(retry(1), catchError(this.handleError));
    }

    uploadActionPlanPpt(file: File, surveyUId: string, engagementScorecardTitle:string): Observable<any> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            })
        };
        let formData: FormData = new FormData();
        formData.append('file', file, file.name);
        formData.append('surveyUId', surveyUId);
        formData.append('engagementScorecardTitle', engagementScorecardTitle);
        return this.httpService.post<any>(`${this.apiUrl}/api/EngagementScorecard/UploadActionPlanPpt`, formData, httpOptions);
    }

    // participant file
    participantFile(file: File): Observable<any> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            })
        };
        let formData: FormData = new FormData();
        formData.append('file', file, file.name);
        return this.httpService.post<any>(`${this.apiUrl}/api/Participant/PreviewParticipantFile`, formData, httpOptions);
    }

    UploadSummaryFile(file: File, surveyUId: string): Observable<any> {
        const formData: FormData = new FormData();
        formData.append('file', file, file.name);
        formData.append('surveyUId', surveyUId);
        return this.httpService.post<any>(`${this.apiUrl}/api/Reports/AddUpdateTopBottomSummaryStatement`,formData);
    }

    uploadEngagementScorecardFile(surveyUId: string, file: File): Observable<any> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            })
        };
        let formData: FormData = new FormData();
        formData.append('file', file, file.name);
        formData.append('surveyUId', surveyUId);
        return this.httpService.post<any>(`${this.apiUrl}/api/EngagementScorecard/UploadEngagementScorecardFile`, formData, httpOptions);
    }
    
    // upload questions from excel
    UploadQuestionsFile(file: File, surveyUId: string): Observable<any> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            })
        };
        const formData: FormData = new FormData();
        formData.append('file', file, file.name);
        formData.append('surveyUId', surveyUId);
        return this.httpService.post<any>(`${this.apiUrl}/api/SurveyQuestionSets/UploadQuestions`,formData, httpOptions);
    }

    public uploadParticipientData(uploadParticipientDataObj) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            })
        };
        const formData = JSON.stringify(uploadParticipientDataObj);
        return this.httpService.post(this.apiUrl + '/api/Participant/UploadParticipantData', formData, httpOptions)
            .pipe(retry(1), catchError(this.handleError));
    }

    public GetPartipantExcelInfoBySurveyUId(surveyUID) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            })
        };
        const formData = JSON.stringify(surveyUID);
        return this.httpService.post(this.apiUrl + '/api/Participant/GetPartipantExcelInfoBySurveyUId?surveyUId=' + surveyUID, formData, httpOptions)
            .pipe(retry(1), catchError(this.handleError));
    }
    
    public getDashboardForSurvey(surveyObj) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            })
        };
        const formData = JSON.stringify(surveyObj);
        return this.httpService.post(this.apiUrl + '/api/Participant/GetDashboardForSurvey', formData, httpOptions)
            .pipe(retry(1), catchError(this.handleError));
    }

        public getAvailableDemographicFilters(surveyObj) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            })
        };
        const formData = JSON.stringify(surveyObj);
        return this.httpService.post(this.apiUrl + '/api/Participant/GetAvailableDemographicFilters', formData, httpOptions)
            .pipe(retry(1), catchError(this.handleError));
    }


    public getDashboardWithFiltersForSurvey(surveyObj) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            })
        };
        const formData = JSON.stringify(surveyObj);
        return this.httpService.post(this.apiUrl + '/api/Participant/DownloadSurveyDashboard', formData, httpOptions)
            .pipe(retry(1), catchError(this.handleError));
    }

    public downloadParticipationDashboardPdf(surveyObj) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            })
        };
        const formData = JSON.stringify(surveyObj);
        return this.httpService.post(this.apiUrl + '/api/Participant/DownloadParticipationDashboardPdf', formData, httpOptions)
            .pipe(retry(1), catchError(this.handleError));
    }

    public downloadEngagementDashboardPdf(surveyObj) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            })
        };
        const formData = JSON.stringify(surveyObj);
        return this.httpService.post(this.apiUrl + '/api/Participant/DownloadEngagementDashboardPdf', formData, httpOptions)
            .pipe(retry(1), catchError(this.handleError));
    }

    // Excel exports are generated server-side (EPPlus) so the HRAnexi/client logos can be
    // embedded as real images, matching the PPT/PDF header alignment.
    downloadParticipationDashboardExcel(surveyObj): Promise<Blob> {
        return new Promise((resolve, reject) => {
            const request = new XMLHttpRequest();
            request.open('POST', this.apiUrl + '/api/Participant/DownloadParticipationDashboardExcel', true);
            request.setRequestHeader('Content-Type', 'application/json');
            request.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem('token'));
            request.responseType = 'blob';

            request.onreadystatechange = () => {
                if (request.readyState === 4) {
                    if (request.status === 200) {
                        resolve(request.response);
                    } else {
                        reject(request.response);
                    }
                }
            };

            request.send(JSON.stringify(surveyObj));
        });
    }

    downloadEngagementDashboardExcel(surveyObj): Promise<Blob> {
        return new Promise((resolve, reject) => {
            const request = new XMLHttpRequest();
            request.open('POST', this.apiUrl + '/api/Participant/DownloadEngagementDashboardExcel', true);
            request.setRequestHeader('Content-Type', 'application/json');
            request.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem('token'));
            request.responseType = 'blob';

            request.onreadystatechange = () => {
                if (request.readyState === 4) {
                    if (request.status === 200) {
                        resolve(request.response);
                    } else {
                        reject(request.response);
                    }
                }
            };

            request.send(JSON.stringify(surveyObj));
        });
    }

    triggerFileDownload(blob: Blob, fileName: string) {
        const linkElement = document.createElement('a');
        const url = window.URL.createObjectURL(blob);
        linkElement.setAttribute('href', url);
        linkElement.setAttribute('download', fileName);
        document.body.appendChild(linkElement);
        linkElement.click();
        document.body.removeChild(linkElement);
        window.URL.revokeObjectURL(url);
    }

    public getEngagementDashboardWithFiltersForSurvey(surveyObj) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            })
        };
        const formData = JSON.stringify(surveyObj);
        return this.httpService.post(this.apiUrl + '/api/Participant/DownloadDashboardForEngagementScore', formData, httpOptions)
            .pipe(retry(1), catchError(this.handleError));
    }

    public validateDashboardLinkPassword(surveyObj) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            })
        };
        const formData = JSON.stringify(surveyObj);
        return this.httpService.post(this.apiUrl + '/api/Participant/ValidateDashboardLinkPassword', formData, httpOptions)
            .pipe(retry(1), catchError(this.handleError));
    }
    
    public shareDashBoardLink(surveyObj) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            })
        };
        const formData = JSON.stringify(surveyObj);
        return this.httpService.post(this.apiUrl + '/api/Participant/ShareDashBoardLink', formData, httpOptions)
            .pipe(retry(1), catchError(this.handleError));
    }

    public disableDashboard(survey) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            })
        };
        return this.httpService.get(this.apiUrl + '/api/Participant/ChangeSharingStatusSurveyDashboard?SurveyUId=' + survey, httpOptions)
            .pipe(retry(1), catchError(this.handleError));
    }

    public shareEngagementDashBoardLink(surveyObj) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            })
        };
        const formData = JSON.stringify(surveyObj);
        return this.httpService.post(this.apiUrl + '/api/Participant/ShareEngagementDashBoardLink', formData, httpOptions)
            .pipe(retry(1), catchError(this.handleError));
    }

    public disableEngagementDashboard(survey) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            })
        };
        return this.httpService.get(this.apiUrl + '/api/Participant/ChangeSharingStatusEngagementDashboard?SurveyUId=' + survey, httpOptions)
            .pipe(retry(1), catchError(this.handleError));
    }

    // Anonymous: persists a Custom Sort drag-and-drop order from the external
    // dashboard, authorized by the share link's own password rather than a
    // Bearer token (external viewers have no authenticated session).
    public updateDashboardCustomSortByLink(payload) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json'
            })
        };
        const formData = JSON.stringify(payload);
        return this.httpService.post(this.apiUrl + '/api/Participant/UpdateDashboardCustomSortByLink', formData, httpOptions)
            .pipe(retry(1), catchError(this.handleError));
    }

    public updateEngagementDashboardCustomSortByLink(payload) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json'
            })
        };
        const formData = JSON.stringify(payload);
        return this.httpService.post(this.apiUrl + '/api/Participant/UpdateEngagementDashboardCustomSortByLink', formData, httpOptions)
            .pipe(retry(1), catchError(this.handleError));
    }

    public getDashBoardByLink(payload) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                // 'Authorization': 'Bearer ' + localStorage.getItem('token')
            })
        };
        const formData = JSON.stringify(payload);
        return this.httpService.post(this.apiUrl + '/api/Participant/GetDashBoardByLink',formData, httpOptions)
            .pipe(retry(1), catchError(this.handleError));
    }

            public getEngagementDashBoardByLink(payload) {
            const httpOptions = {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json-patch+json'
                    // 'Authorization': 'Bearer ' + localStorage.getItem('token')
                })
            };
            const formData = JSON.stringify(payload);
            return this.httpService.post(
                this.apiUrl + '/api/Participant/GetEngagementDashBoardByLink',
                formData,
                httpOptions
            ).pipe(
                retry(1),
                catchError(this.handleError)
            );
        }

    public getDashBoardForEngagementScore(obj) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            })
        };
        const formData = JSON.stringify(obj);
        return this.httpService.post(this.apiUrl + '/api/Participant/GetDashBoardForEngagementScore',formData, httpOptions)
            .pipe(retry(1), catchError(this.handleError));
    }

    public getPartipantExcelInfoForEngagementDashboard(surveyUID) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            })
        };
        return this.httpService.get(this.apiUrl + '/api/Participant/GetPartipantExcelInfoBySurveyUIdForEngagementDashboard?surveyUId=' + surveyUID, httpOptions)
            .pipe(retry(1), catchError(this.handleError));
    }

    public getSurveyResponseStatement(surveyUID) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            })
        };
        return this.httpService.get(this.apiUrl + '/api/Participant/GetSurveyResponseStatementDashboard?surveyUId=' + surveyUID, httpOptions)
            .pipe(retry(1), catchError(this.handleError));
    }

    // this method returns list of survey
    public getSurveyList() {
        const httpOptions = {
            headers: new HttpHeaders({
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            })
        };
        return this.httpService.get(this.apiUrl + '/api/Surveys/GetAll', httpOptions)
            .pipe(retry(1), catchError(this.handleError));
    }

    public getAllSurvey(obj): Observable<any[]> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            })
        };
        return this.httpService.post<any[]>(this.apiUrl + '/api/Surveys/GetAllSurvey', obj, httpOptions)
            .pipe(retry(1), catchError(this.handleError));
    }

    public getAllClient(obj): Observable<any[]> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            })
        };
        return this.httpService.post<any[]>(this.apiUrl + '/api/Clients/GetAllClient', obj, httpOptions)
            .pipe(retry(1), catchError(this.handleError));
    }

    public deleteClientReport(data) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            })
        };
        let body = JSON.stringify(data);
        return this.httpService.post(this.apiUrl + '/api/Surveys/DeleteSurveyReports', body, httpOptions).pipe(retry(1), catchError(this.handleError));
    }

    DeleteSurveyInstructions(id) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            })
        };
        return this.httpService.get(this.apiUrl + '/api/Surveys/DeleteSurveyInstructions?id=' + id, httpOptions).pipe(retry(1), catchError(this.handleError));
    }


    public copySurvey(id) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            })
        };
        return this.httpService.get(this.apiUrl + '/api/Surveys/CopySurvey?id=' + id, httpOptions).pipe(retry(1), catchError(this.handleError));
    }

    public getAllClientReport(uid): Observable<any[]> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            })
        };
        return this.httpService.get<any[]>(this.apiUrl + '/api/Surveys/GetAllSurveyReports?surveyUId=' + uid, httpOptions)
            .pipe(retry(1), catchError(this.handleError));
    }

    public GetAccessList() {
        const httpOptions = {
            headers: new HttpHeaders({
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            })
        };
        return this.httpService.get(this.apiUrl + '/api/Surveys/GetAccessList', httpOptions)
            .pipe(retry(1), catchError(this.handleError));
    }

    // this method returns a particular survey by it's id
    public getSurvey(uId) {
        return this.httpService.get(this.apiUrl + '/api/Surveys/GetByUId?uId=' + uId)
            .pipe(retry(1), catchError(this.handleError));
    }



    // API for checking link id present of not / survey submitted or not.

    public isLinkIdPresent(presentId) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            })
        };
        return this.httpService.get(this.apiUrl + '/api/Surveys/IsLinkIdPresent?id=' + presentId, httpOptions)
            .pipe(retry(1), catchError(this.handleError));
    }

    // this method adds a survey
    public addSurvey(survey) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            })
        };
        const formData = JSON.stringify(survey);
        return this.httpService.post(this.apiUrl + '/api/Surveys/Post', formData, httpOptions)
            .pipe(retry(1), catchError(this.handleError));
    }

    // this method adds a survey question
    public addSurveyQuestion(questionObj) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            })
        };
        const formData = JSON.stringify(questionObj);
        return this.httpService.post(this.apiUrl + '/api/SurveyQuestionSets/AddQuestion', formData, httpOptions)
            .pipe(retry(1), catchError(this.handleError));
    }


    public publishSurvey(publishsurvey) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            })
        };
        const formData = JSON.stringify(publishsurvey);
        return this.httpService.post(this.apiUrl + '/api/Surveys/PublishSurvey', formData, httpOptions)
            .pipe(retry(1), catchError(this.handleError));
    }

    public closeSurvey(closesurvey) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            })
        };
        const formData = JSON.stringify(closesurvey);
        return this.httpService.post(this.apiUrl + '/api/Surveys/CloseSurvey', formData, httpOptions)
            .pipe(retry(1), catchError(this.handleError));
    }



    public updateQuestion(questionObj) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            })
        };
        const formData = JSON.stringify(questionObj);
        return this.httpService.post(this.apiUrl + '/api/SurveyQuestionSets/UpdateQuestion', formData, httpOptions)
            .pipe(retry(1), catchError(this.handleError));
    }

    public updateQuestionSet(questionObj) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            })
        };
        const formData = JSON.stringify(questionObj);
        return this.httpService.post(this.apiUrl + '/api/SurveyQuestionSets/UpdateQuestionSet', formData, httpOptions)
            .pipe(retry(1), catchError(this.handleError));
    }

    public getSurveyQuestionSet(uid) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            })
        };
        return this.httpService.get(this.apiUrl + '/api/SurveyQuestionSets/GetBySurveyUId?uId=' + uid, httpOptions)
            .pipe(retry(1), catchError(this.handleError));
    }


    public getSurveyQuestionSetbylink(linkId) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            })
        };
        return this.httpService.get(this.apiUrl + '/api/SurveyQuestionSets/GetBySurveyLinkId?id=' + linkId, httpOptions)
            .pipe(retry(1), catchError(this.handleError));
    }


    // this method adds a client to the data base
    public addClient(client) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            })
        };
        const formData = JSON.stringify(client);
        return this.httpService.post(this.apiUrl + '/api/Clients/Post', formData, httpOptions)
            .pipe(retry(1), catchError(this.handleError));
    }


    public UploadSurveyFile(uId) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            })
        };
        const formData = JSON.stringify(uId);
        return this.httpService.post(this.apiUrl + '/api/Surveys/UploadSurveyFile', formData, httpOptions)
            .pipe(retry(1), catchError(this.handleError));
    }

    // for invitation code
    public isInvitationCodePresent(sUId, icode) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            })
        };
        return this.httpService.get(this.apiUrl + '/api/Surveys/IsInvitationCodePresent?sUId=' + sUId + '&invitationCode=' + icode, httpOptions)
            .pipe(retry(1), catchError(this.handleError));
    }

    makeFileRequest(surveyUId) {
        // const headers = new Headers();
        // headers.append('Authorization', 'Bearer ' + localStorage.getItem('token'));
        return new Promise((resolve, reject) => {
            const downloadRequest = new XMLHttpRequest();
            downloadRequest.open('GET', this.apiUrl + '/api/Surveys/GetUsersForSurvey?sUId=' + surveyUId, true);
            downloadRequest.setRequestHeader('Content-Type', 'application/json');
            downloadRequest.responseType = 'blob';
            downloadRequest.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem('token'));
            downloadRequest.onreadystatechange = function () {
                if (downloadRequest.readyState === 4) {
                    if (downloadRequest.status === 200) {
                        resolve(downloadRequest.response);
                    } else {
                        // alert('File not Found, No participant added.');
                        Swal.fire({
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            position: 'center',
                            title: 'Oops...',
                            text: 'File not Found, No participant added!',
                            type: 'error'
                        });
                        reject(downloadRequest.response);
                    }
                }
            };
            downloadRequest.send();
        });
    }

    DownloadRawResponse(payload: any): Promise<Blob> {
        return new Promise((resolve, reject) => {
            const request = new XMLHttpRequest();
            request.open('POST', this.apiUrl + '/api/SurveyQuestionSetResponses/DownloadRawResponse', true);
            request.setRequestHeader('Content-Type', 'application/json');
            request.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem('token'));
            request.responseType = 'blob'; // ✅ Ensure this line is before `send()`

            request.onreadystatechange = () => {
                if (request.readyState === 4) {
                    if (request.status === 200) {
                        resolve(request.response); // ✅ This will now be of type `Blob`
                    } else {
                        reject(request.response);
                    }
                }
            };
            request.send(JSON.stringify(payload)); // ✅ Make sure `surveyUId` is spelled correctly if the backend expects `uId`
        });
    }

    public UpdateSurvey(survey) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            })
        };
        return this.httpService.post(this.apiUrl + '/api/Surveys/UpdateSurvey', survey, httpOptions)
            .pipe(retry(1), catchError(this.handleError));
    }

    // this method returns all client list
    public getClientList() {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            })
        };
        return this.httpService.get(this.apiUrl + '/api/Clients/GetAll', httpOptions)
            .pipe(retry(1), catchError(this.handleError));
    }


    public SendInvitationEmail(surveyInvEmailObj) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            })
        };
        return this.httpService.post(this.apiUrl + '/api/Surveys/SendInvitationEmail', surveyInvEmailObj, httpOptions)
            .pipe(retry(1), catchError(this.handleError));
    }

    public SendReminderEmail(surveyRemiEmailObj) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            })
        };
        return this.httpService.post(this.apiUrl + '/api/Surveys/SendReminderEmail', surveyRemiEmailObj, httpOptions)
            .pipe(retry(1), catchError(this.handleError));
    }

    public deleteSurvey(id) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            })
        };
        return this.httpService.post(this.apiUrl + '/api/Surveys/DeleteByUId?uId=' + id, {},
            httpOptions).pipe(retry(1), catchError(this.handleError));
    }

    public deleteQuestion(deleteobj) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            }),
            body: deleteobj
        };
        return this.httpService.delete(this.apiUrl + '/api/SurveyQuestionSets/DeleteQuestion', httpOptions).pipe(retry(1), catchError(this.handleError));
    }

    private handleError(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error(
                `Backend returned code ${error.status}, ` +
                `body was: ${error.error}`);
        }
        // return an observable with a user-facing error message
        return throwError(error);
    }

    public getAllSurveyInstructions(uid) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            })
        };
        return this.httpService.get(this.apiUrl + '/api/Surveys/GetAllSurveyInstructions?surveyUId=' + uid, httpOptions)
            .pipe(retry(1), catchError(this.handleError));
    }

    public AddSurveyInstruction(data) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            })
        };
        const formData = JSON.stringify(data);
        return this.httpService.post(this.apiUrl + '/api/Surveys/AddOrUpdateSurveyInstruction', formData, httpOptions)
            .pipe(retry(1), catchError(this.handleError));
    }

    public addDashboardConfiguration(config) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            })
        };
        const formData = JSON.stringify(config);
        return this.httpService.post(this.apiUrl + '/api/Participant/CreateUpdateDashboardConfiguration', formData, httpOptions)
            .pipe(retry(1), catchError(this.handleError));
    }

    public getDashboardConfig(uid) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            })
        };
        return this.httpService.get(this.apiUrl + '/api/Participant/GetDashboardConfiguration?surveyUId=' + uid, httpOptions)
            .pipe(retry(1), catchError(this.handleError));
    }

        uploadLogo(file: File): Observable<any> {
        let formData: FormData = new FormData();
        formData.append('file', file, file.name);
        return this.httpService.post<any>(`${this.apiUrl}/api/Participant/UploadClientLogo`, formData);
    }

}
